export default function WhyUs() {
  const reasons = [
    {
      icon: 'ri-shield-check-line',
      title: 'Стратегия, а не догадки',
      description: 'Каждое решение основано на данных и маркетинговой аналитике. Мы проектируем путь клиента до первого клика, а не после.',
    },
    {
      icon: 'ri-rocket-line',
      title: 'Технологическое превосходство',
      description: 'Современный стек, SEO-архитектура и скорость загрузки — всё настроено так, чтобы Google и Яндекс «любили» ваш сайт.',
    },
    {
      icon: 'ri-time-line',
      title: 'Ваше время — ценность',
      description: 'Мы берём рутину на себя. Сайт работает на вас 24/7, квалифицирует лидов и продаёт вашу экспертность без вашего участия.',
    },
  ];

  const stats = [
    { value: '35+', label: 'Успешных проектов' },
    { value: '×3.5', label: 'Средний рост продаж' },
    { value: '85%', label: 'Довольных клиентов' },
  ];

  return (
    <section className="py-24" style={{ background: '#F8F9FA' }}>
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="text-center mb-16">
          <p
            className="text-sm font-semibold tracking-widest uppercase mb-4"
            style={{ color: '#C5A880', fontFamily: 'Montserrat, sans-serif' }}
          >
            Наши преимущества
          </p>
          <h2
            className="text-4xl md:text-5xl font-bold mb-6"
            style={{ color: '#1A2B4C', fontFamily: 'Playfair Display, serif' }}
          >
            Почему мы?
          </h2>
          <div className="w-16 h-0.5 mx-auto mb-6" style={{ background: '#C5A880' }}></div>
          <p
            className="text-lg max-w-2xl mx-auto"
            style={{ color: '#4A5568', fontFamily: 'Montserrat, sans-serif' }}
          >
            Мы — ваш стратегический партнёр, а не просто подрядчик
          </p>
        </div>

        {/* Reason cards */}
        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              style={{ border: '1px solid #E8E0D5' }}
            >
              {/* Top colored bar */}
              <div className="h-1 w-full" style={{ background: '#C5A880' }}></div>

              {/* Icon area */}
              <div
                className="flex items-center justify-center py-10"
                style={{ background: '#1A2B4C' }}
              >
                <div
                  className="w-20 h-20 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-110"
                  style={{ background: 'rgba(197,168,128,0.15)', border: '1px solid #C5A880' }}
                >
                  <i className={`${reason.icon} text-4xl`} style={{ color: '#C5A880' }}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                {/* Ghost number */}
                <div
                  className="text-7xl font-bold leading-none mb-4 select-none"
                  style={{ color: '#F0EDE8', fontFamily: 'Playfair Display, serif' }}
                >
                  0{index + 1}
                </div>
                <h3
                  className="text-xl font-bold mb-3"
                  style={{ color: '#1A2B4C', fontFamily: 'Playfair Display, serif' }}
                >
                  {reason.title}
                </h3>
                <p
                  className="text-sm leading-relaxed"
                  style={{ color: '#6B7280', fontFamily: 'Montserrat, sans-serif' }}
                >
                  {reason.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom dark banner */}
        <div
          className="rounded-3xl p-12 shadow-2xl relative overflow-hidden"
          style={{ background: '#1A2B4C' }}
        >
          {/* Decorative rings */}
          <div
            className="absolute -top-16 -right-16 w-64 h-64 rounded-full opacity-10"
            style={{ border: '2px solid #C5A880' }}
          ></div>
          <div
            className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full opacity-10"
            style={{ border: '2px solid #C5A880' }}
          ></div>

          <div className="relative flex flex-col lg:flex-row items-center gap-12">
            {/* Left text */}
            <div className="flex-1 text-center lg:text-left">
              <h3
                className="text-3xl md:text-4xl font-bold text-white mb-4"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                Мы не просто делаем сайты
              </h3>
              <p
                className="text-lg leading-relaxed"
                style={{ color: 'rgba(255,255,255,0.72)', fontFamily: 'Montserrat, sans-serif' }}
              >
                Мы строим систему, которая работает на вас 24/7, постоянно оптимизируется и масштабируется. Наша цель — сделать ваш маркетинг автономным и предсказуемым.
              </p>
            </div>

            {/* Divider */}
            <div className="hidden lg:block w-px h-24 opacity-20" style={{ background: '#C5A880' }}></div>

            {/* Stats */}
            <div className="flex flex-row lg:flex-col gap-8 lg:gap-6">
              {stats.map((stat, i) => (
                <div key={i} className="text-center lg:text-right">
                  <div
                    className="text-4xl font-bold"
                    style={{ color: '#C5A880', fontFamily: 'Playfair Display, serif' }}
                  >
                    {stat.value}
                  </div>
                  <div
                    className="text-sm mt-1"
                    style={{ color: 'rgba(255,255,255,0.6)', fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
